define( [
	"../var/document"
], function( document ) {
	"use strict";

	function DOMEval( code, doc ) {
		doc = doc || document;

		var script = doc.createElement( "script" );

		script.text = code;
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}

	return DOMEval;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/core/DOMEval.js
// module id = 441
// module chunks = 17 22 23